import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useNavigate } from 'react-router-dom';

const UnAuthorizedPage = () => {
  const navigator = useNavigate();
  const handleClose = () => {
    navigator('/login');
  };

  return (
    <div>
      <Dialog
        open
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            セッション期限が切れました、再ログインしてください
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ログインページへ</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UnAuthorizedPage;
